<p-breadcrumb
  [model]="[
    { label: 'Ofertas', routerLink: ['/offers'] },
    {
      label: offerId() ? 'Editar Oferta' : 'Nova Oferta',
      routerLink: offerId()
        ? ['/offers/update/' + offerId()]
        : ['/offers/create'],
    },
  ]"
  [home]="{ label: '', routerLink: ['/'], icon: 'ph-duotone ph-house text-lg' }"
/>

<form [formGroup]="formGroup" (ngSubmit)="onSubmit()" class="relative">
  <p-toolbar class="mb-5 mt-5">
    <div class="w-full flex flex-wrap justify-between items-center">
      <div>
        @if (offerId()) {
          <h5 class="font-bold">Editar Oferta</h5>
          <p>Confira e atualize informações</p>
        } @else {
          <h5 class="font-bold">Cadastrar Nova Oferta</h5>
          <p>Preencha os campos abaixo para cadastrar</p>
        }
      </div>
      <div class="flex justify-end gap-5 items-center">
        <div class="w-full flex items-center gap-1">
          <label for="isActive"> Status: </label><br />
          <p-select
            formControlName="status"
            [options]="statusOptions"
            optionLabel="label"
            optionValue="value"
            placeholder="Selecione o status"
            class="w-full"
          >
          </p-select>
          <app-form-error [control]="formGroup.get('status')" />
          <app-form-server-error [control]="formGroup.get('status')" />
        </div>

        <div class="flex gap-2">
          <p-button
            label="Cancelar"
            routerLink="/offers"
            severity="secondary"
            rounded
            class="btn-secondary-outline"
          >
          </p-button>
          <p-button type="submit" label="Salvar" rounded></p-button>
        </div>
      </div>
    </div>
  </p-toolbar>

  <div class="card space-y-5 w-full">
    <h5 class="font-bold">Informações Gerais</h5>

    <div class="flex flex-wrap xl:flex-nowrap gap-5">
      <div class="w-full">
        <label for="name">Nome *</label>
        <input
          pInputText
          type="text"
          formControlName="name"
          class="w-full"
          placeholder="Informe o nome"
        />
        <app-form-error [control]="formGroup.get('name')" />
        <app-form-server-error [control]="formGroup.get('name')" />
      </div>

      <div class="w-full">
        <label for="productId">Produto *</label>
        <p-select
          formControlName="productId"
          [options]="productsDropdown()"
          [loading]="productSelectLoading()"
          optionLabel="label"
          [filter]="true"
          filterBy="label"
          placeholder="Selecione o produto"
          class="w-full"
          [showClear]="true"
        >
        </p-select>
        <app-form-error [control]="formGroup.get('productId')" />
        <app-form-server-error [control]="formGroup.get('productId')" />
      </div>
    </div>

    <h5 class="font-bold">Pagamento</h5>

    <div class="flex flex-wrap xl:flex-nowrap gap-5">
      <div class="w-full">
        <label for="paymentFrequencyId">Frequência de Pagamento *</label>
        <p-select
          formControlName="paymentFrequencyId"
          [options]="paymentFrequenciesDropdown()"
          [loading]="paymentFrequencySelectLoading()"
          optionLabel="label"
          [filter]="true"
          filterBy="label"
          placeholder="Selecione a frequência"
          class="w-full"
          [showClear]="true"
        >
        </p-select>
        <app-form-error [control]="formGroup.get('paymentFrequencyId')" />
        <app-form-server-error
          [control]="formGroup.get('paymentFrequencyId')"
        />
      </div>
      <div class="w-full">
        <label for="fullPrice">Taxa de Juros *</label>
        <input
          pInputText
          formControlName="interestRate"
          (input)="onCurrencyInput('interestRate', $event)"
          class="w-full"
        />
        <app-form-error [control]="formGroup.get('interestRate')" />
        <app-form-server-error [control]="formGroup.get('interestRate')" />
      </div>
    </div>

    <div class="flex flex-wrap xl:flex-nowrap gap-5">
      <div class="w-full">
        <label for="installmentCount">Quantidade de Parcelas *</label>
        <p-inputNumber
          formControlName="installmentCount"
          inputId="installmentCount"
          [useGrouping]="false"
          [min]="1"
          class="w-full"
        />
        <app-form-error [control]="formGroup.get('installmentCount')" />
        <app-form-server-error [control]="formGroup.get('installmentCount')" />
      </div>

      <div class="w-full">
        <label for="installmentAmount">Valor da Parcela * </label>
        <input
          pInputText
          formControlName="installmentAmount"
          (input)="onCurrencyInput('installmentAmount', $event)"
          class="w-full"
        />
        <app-form-error [control]="formGroup.get('installmentAmount')" />
        <app-form-server-error [control]="formGroup.get('installmentAmount')" />
      </div>

      <div class="w-full">
        <label for="downPayment">Valor da Entrada</label>
        <input
          pInputText
          formControlName="downPayment"
          (input)="onCurrencyInput('downPayment', $event)"
          class="w-full"
        />
        <app-form-error [control]="formGroup.get('downPayment')" />
        <app-form-server-error [control]="formGroup.get('downPayment')" />
      </div>

      <div class="w-full">
        <label for="fullPrice">Valor Total do Produto </label>
        <input
          pInputText
          formControlName="fullPrice"
          readonly
          class="w-full bg-surface-200! text-surface-600! dark:bg-surface-800! dark:text-surface-300! cursor-not-allowed"
        />
        <app-form-error [control]="formGroup.get('fullPrice')" />
        <app-form-server-error [control]="formGroup.get('fullPrice')" />
      </div>
    </div>

    <div class="flex flex-wrap xl:flex-nowrap gap-5">
      <div class="w-full">
        <label for="cashPrice">Preço a Vista *</label>
        <input
          pInputText
          formControlName="cashPrice"
          (input)="onCurrencyInput('cashPrice', $event)"
          class="w-full"
        />
        <app-form-error [control]="formGroup.get('cashPrice')" />
        <app-form-server-error [control]="formGroup.get('cashPrice')" />
      </div>

      <div class="w-full">
        <label for="lateFeePolicyId">Multa</label>
        <p-select
          formControlName="lateFeePolicyId"
          [options]="lateFeePoliciesDropdown()"
          [loading]="lateFeePolicySelectLoading()"
          optionLabel="label"
          [filter]="true"
          filterBy="label"
          placeholder="Selecione a multa"
          class="w-full"
          [showClear]="true"
        >
        </p-select>
        <app-form-error [control]="formGroup.get('lateFeePolicyId')" />
        <app-form-server-error [control]="formGroup.get('lateFeePolicyId')" />
      </div>
    </div>
  </div>

  @if (loading()) {
    <div
      class="absolute inset-0 z-30 flex items-center justify-center bg-black/20 backdrop-blur-sm rounded-lg"
    >
      <p-progress-spinner ariaLabel="loading"></p-progress-spinner>
    </div>
  }
</form>

<p-toast />
